import { OrbitControls, OrthographicCamera, BakeShadows, ContactShadows, Box } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import { Model } from './room.jsx'
import { NodeToyTick } from '@nodetoy/react-nodetoy';
import { useControls } from 'leva'
import Player from './Player.jsx'
import { Physics } from '@react-three/rapier'


export default function Experience() {

  return <>

    <Perf position="top-left" />
    <OrbitControls makeDefault />
    <directionalLight
      castShadow position={[2.5, 8, 5]}
      shadow-mapSize={[1024, 1024]}
      shadow-camera-near={1}
      shadow-camera-far={10}
      shadow-camera-top={10}
      shadow-camera-right={10}
      shadow-camera-bottom={-10}
      shadow-camera-left={-10}
      intensity={0.3}
    >


{/*       <OrthographicCamera
        makeDefault
        attach="shadow-camera"
        zoom={40}
        near= {0.1}
        far= {200}
        position= {[ 2.5, 4, 6 ]}
       // near={1}
       // far={2000}
       // position={[-2, 3, 30]}
      
      /> */}
    </directionalLight>

    <ambientLight intensity={0.1} />
    <Physics>
      <Model />
      <ContactShadows rotation-x={Math.PI / 2} position={[0, -0.8, 0]} opacity={0.25} width={10} height={10} blur={2} far={1} />
      <BakeShadows />
      <NodeToyTick />
      <Player />
    </Physics>
  </>
}